import i18n from '@/plugins/i18n/index.js'

export default function transTypes () {
  return [
    { category: i18n.t('general.restaurant'), label: 'restaurant' },
    { category: i18n.t('general.bar'), label: 'bar' },
    { category: i18n.t('general.hotel'), label: 'hotel' },
    { category: i18n.t('general.museum'), label: 'museum' },
    { category: i18n.t('general.cultureHouse'), label: 'culture house' },
    { category: i18n.t('general.park'), label: 'park' },
    { category: i18n.t('general.gym'), label: 'gym' },
    { category: i18n.t('general.comercialCenter'), label: 'comercialCenter' },
    { category: i18n.t('general.theatre'), label: 'theatre' },
    { category: i18n.t('general.cafe'), label: 'cafe' },
    { category: i18n.t('general.library'), label: 'library' },
    { category: i18n.t('general.house'), label: 'house' }
  ]
}
